import { React } from 'react';
import sampleLogo from '../Assets/Images/HHG_Final_Logo_2.png'
import { Link } from "react-router-dom";
import Home from '../Views/Home';
import { color } from 'three/tsl';
import locationIcon from '../Assets/icon/Vectorloc.png'; // update path as per your structure


const Footer = () => {
    return(
        <footer itemscope="itemscope" itemtype="https://schema.org/WPFooter">
	        <div data-elementor-type="page" data-elementor-id="1046" class="elementor elementor-1046">
				<div class="elementor-element elementor-element-763a292 e-flex e-con-boxed e-con e-parent" data-id="763a292" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
		<div class="elementor-element elementor-element-cfba508 e-con-full e-flex e-con e-child" data-id="cfba508" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
<div className="custom-logo elementor-element elementor-element-71d6839 e-con-full e-flex e-con e-child" data-id="71d6839" data-element_type="container" data-settings='{"content_width":"full"}'>
  {/* Logo */}
  <div className="elementor-element elementor-element-d093d54 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="d093d54" data-element_type="widget" data-widget_type="image.default">
    <div className="elementor-widget-container">
      <Link to="/">
        <img 
          fetchpriority="high"
          width="450"
          height="100"
          src={sampleLogo}
          className="attachment-large size-large wp-image-1666"
          alt="Home Logo"
          decoding="async"
          sizes="(max-width: 481px) 100vw, 481px"
          style={{ paddingTop: "11px", cursor: "pointer" }}
        />
      </Link>
    </div>
  </div>

  {/* Subtitle */}
  <div className="elementor-element elementor-element-1fbd715 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor" data-id="1fbd715" data-element_type="widget" data-widget_type="text-editor.default">
    <div className="elementor-widget-container" style={{ marginTop: "10px", fontSize: "15px", lineHeight: "1.6" }}>
      This insightful exploration delves into the latest advances in robotic technologies, artificial intelligence, and automation.
    </div>
  </div>

  {/* Address with Image Icon */}
  <div style={{ display: "flex", alignItems: "center", marginTop: "15px", fontSize: "14px", color: "#333" }}>
    <img
      src={locationIcon}
      alt="Location Icon"
      style={{ width: "18px", height: "18px", marginRight: "8px" , marginLeft:'-30px'}}
    />
    <span>
     5th Floor Urbanwrk, West Port, 54, Pancard Club Rd,<br/> Baner, Pune, Maharashtra 411069

    </span>
  </div>
  <div style={{ display: "flex", alignItems: "center", marginTop: "15px", fontSize: "14px", color: "#333" }}>
    <img
      src={locationIcon}
      alt="Location Icon"
      style={{ width: "18px", height: "18px", marginRight: "8px" , marginLeft:'-30px'}}
    />
    <span>
    42/2, Savli GIDC Rd, Vadodara, Manjusar, Gujarat 391776

    </span>
  </div>
</div>

		<div class="elementor-element elementor-element-57af291 e-con-full e-flex e-con e-child" data-id="57af291" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-3003d0f elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="3003d0f" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h4 class="elementor-heading-title elementor-size-default">Quick Links</h4>		</div>
				</div>
				<div class="elementor-element elementor-element-dd63177 elementor-widget__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="dd63177" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
				<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<a href="/">

											<span class="elementor-icon-list-text">Home</span>
											</a>
									</li>
								
								{/* <li class="elementor-icon-list-item">
											<a href="/about">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li> */}
								{/* <li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Team</span>
											</a>
									</li> */}
									
								<li class="elementor-icon-list-item">
											<a href="Products">

											<span class="elementor-icon-list-text">Products</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="about">

											<span class="elementor-icon-list-text">About</span>
											</a>
									</li>
									
									<li class="elementor-icon-list-item">
											<a href="ContactUs">

											<span class="elementor-icon-list-text">Contact</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="Career">

											<span class="elementor-icon-list-text">Career</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="TermsOfService">

											<span class="elementor-icon-list-text">Terms Of Service</span>
											</a>
									</li>
<li class="elementor-icon-list-item">
											<a href="PrivacyPolicy">

											<span class="elementor-icon-list-text">Privacy Policy</span>
											</a>
									</li>
						</ul>
				</div>
				</div>
				</div>
				<div class="elementor-element elementor-element-57af291 e-con-full e-flex e-con e-child" data-id="57af291" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-3003d0f elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="3003d0f" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			{/* <h4 class="elementor-heading-title elementor-size-default">Services</h4>		 */}
			</div>
				</div>
				<div class="elementor-element elementor-element-dd63177 elementor-widget__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="dd63177" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
				{/* <ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<a href="/robotic">

											<span class="elementor-icon-list-text">Robotic Solutions</span>
											</a>
									</li>
								<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li>
								<li class="elementor-icon-list-item">
											<a href="/about">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li>
								<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Team</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Prototyping</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Design & Consultation</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="/printing">

											<span class="elementor-icon-list-text">3D Printing</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="/scanning">

											<span class="elementor-icon-list-text">3D Scanning</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="/Career">

											<span class="elementor-icon-list-text">Career</span>
											</a>
									</li>
						</ul> */}
				</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-bf9662a e-con-full e-flex e-con e-child" data-id="bf9662a" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-dc46677 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="dc46677" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h4 class="elementor-heading-title elementor-size-default">Contact Info</h4>		</div>
				</div>
				{/* <div class="elementor-element elementor-element-c848495 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="c848495" data-element_type="widget" data-widget_type="jkit_icon_box.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_29_676b79794d8d1" ><div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-"><div class="icon style-color"><i aria-hidden="true" class="fas fa-envelope"></i></div></div><div class="icon-box icon-box-body">
                <h6 class="title">Email</h6><p class="icon-box-description">inquiry@hhgindia.com</p>
            </div>
            
            </div></div>		</div>
				</div> */}
				<div class="elementor-element elementor-element-c848495 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="c848495" data-element_type="widget" data-widget_type="jkit_icon_box.default">
    <div class="elementor-widget-container">
        <div class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_29_676b79794d8d1">
            <div class="jkit-icon-box-wrapper hover-from-left">
                <div class="icon-box icon-box-header elementor-animation-">
                    <div class="icon style-color">
                        <i aria-hidden="true" class="fas fa-envelope"></i>
                    </div>
                </div>
                <div class="icon-box icon-box-body">
                    <h6 class="title">Email</h6>
                    <p class="icon-box-description">
					<a href="mailto:inquiry@hhgindia.com" style={{ color: '#605c5c' }}>inquiry@hhgindia.com</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

				<div class="elementor-element elementor-element-3073f44 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="3073f44" data-element_type="widget" data-widget_type="jkit_icon_box.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_30_676b79794e8b5" >
				<div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-">
					<div class="icon style-color"><i aria-hidden="true" class="fas fa-phone-alt"></i></div></div>
					<div class="icon-box icon-box-body">
                <h6 class="title">Contact for Queries</h6><p class="icon-box-description">+91 97260 55997</p>
				
            </div>
           
            </div>
			
			
			</div>		
			
			
			</div>
			
				</div>
				<div class="elementor-element elementor-element-3073f44 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="3073f44" data-element_type="widget" data-widget_type="jkit_icon_box.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_30_676b79794e8b5" >
				<div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-">
					<div class="icon style-color"><i aria-hidden="true" class="fas fa-phone-alt"></i></div></div>
					<div class="icon-box icon-box-body">
			<h6 class="title">Contact for Career </h6><p class="icon-box-description">+91 70699 90856</p>
				
            </div>
           
            </div>
			
			
			</div>		
			
			
			</div>
			
				</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-7ec5110 e-con-full e-flex e-con e-child" data-id="7ec5110" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		<div class="elementor-element elementor-element-4e79600 e-con-full e-flex e-con e-child" data-id="4e79600" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-a883e73 elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget__width-initial elementor-widget elementor-widget-heading" data-id="a883e73" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h3 class="elementor-heading-title elementor-size-default">Subscribe Our Newsletter!</h3>		</div>
				</div>
				<div class="elementor-element elementor-element-490d3d5 elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_mailchimp" data-id="490d3d5" data-element_type="widget" data-widget_type="jkit_mailchimp.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-mailchimp style-inline jeg_module_6_31_676b797951400" ><form method="post" class="jkit-mailchimp-form" data-listed="" data-success-message="Successfully listed this email" data-error-message="Something went wrong">
            <div class="jkit-mailchimp-message"></div>
            <div class="jkit-form-wrapper email-form">
                <div class="jkit-mailchimp-email jkit-input-wrapper input-container">
            <div class="jkit-form-group">
                <div class="jkit-input-element-container jkit-input-group">
                    <input type="email" name="email" class="jkit-email jkit-form-control " placeholder="Your Email Address" required="" />
                </div>
            </div>
        </div><div class="jkit-submit-input-holder jkit-input-wrapper">
            <button type="submit" class="jkit-mailchimp-submit position-after" name="jkit-mailchimp">
                Subscribe Now
            </button>
        </div>
            </div>
        </form></div>		</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-9d91a4f e-con-full e-flex e-con e-child" data-id="9d91a4f" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}" style={{alignItems:'center'}}>
				<div class="elementor-element elementor-element-180ff39 e-grid-align-right e-grid-align-tablet-left e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 elementor-widget elementor-widget-social-icons" data-id="180ff39" data-element_type="widget" data-widget_type="social-icons.default">
				<div class="elementor-widget-container">
					<div className="elementor-social-icons-wrapper elementor-grid">

    {/* Facebook */}
    <span className="elementor-grid-item">
        <a
            className="elementor-icon elementor-social-icon elementor-social-icon-facebook"
            href="https://www.facebook.com/profile.php?viewas=100000686899395&id=61580761602005"
            target="_blank"
			style={{padding:'15px'}}
        >
            <span className="elementor-screen-only">Facebook</span>
            <i className="fab fa-facebook-f"></i>
        </a>
    </span>

    {/* X (Twitter) */}
    <span className="elementor-grid-item">
        <a
            className="elementor-icon elementor-social-icon elementor-social-icon-x"
            href="https://x.com/HHGIndustries"
            target="_blank"
			style={{padding:'15px'}}
        >
            <span className="elementor-screen-only">X</span>
            <i className="fab fa-twitter"></i>
        </a>
    </span>

    {/* YouTube */}
    <span className="elementor-grid-item">
        <a
            className="elementor-icon elementor-social-icon elementor-social-icon-youtube"
            href="https://www.youtube.com/@hhgindustries"
            target="_blank"
			style={{padding:'15px'}}
        >
            <span className="elementor-screen-only">YouTube</span>
            <i className="fab fa-youtube"></i>
        </a>
    </span>

    {/* Instagram */}
    <span className="elementor-grid-item">
        <a
            className="elementor-icon elementor-social-icon elementor-social-icon-instagram"
            href="https://www.instagram.com/hhgindustries/"
            target="_blank"
			style={{padding:'15px'}}
        >
            <span className="elementor-screen-only">Instagram</span>
            <i className="fab fa-instagram"></i>
        </a>
    </span>

    {/* LinkedIn */}
    <span className="elementor-grid-item">
        <a
            className="elementor-icon elementor-social-icon elementor-social-icon-linkedin"
            href="https://www.linkedin.com/company/hhg-industries-private-limited"
            target="_blank"
			style={{padding:'15px'}}
        >
            <span className="elementor-screen-only">LinkedIn</span>
            <i className="fab fa-linkedin"></i>
        </a>
    </span>

</div>

				</div>
				</div>
				</div>
				</div>
					</div>
				</div>
		<div class="elementor-element elementor-element-c7e9be9 e-flex e-con-boxed e-con e-parent" data-id="c7e9be9" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
				<div class="elementor-element elementor-element-363a7b0 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor" data-id="363a7b0" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							Copyright © 2024 HHG Industries Private Limited. All rights reserved.						</div>
				</div>
				<div class="elementor-element elementor-element-40138f6 elementor-icon-list--layout-inline elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="40138f6" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items elementor-inline-items">
							<li class="elementor-icon-list-item elementor-inline-item">
											<a href="TermsOfService">

											<span class="elementor-icon-list-text">Terms & Conditions</span>
											</a>
									</li>
								<li class="elementor-icon-list-item elementor-inline-item">
											<a href="PrivacyPolicy">

											<span class="elementor-icon-list-text">Privacy Policy</span>
											</a>
									</li>
						</ul>
				</div>
				</div>
					</div>
				</div>
							</div>
						</footer>
    )
}

export default Footer;


// import React from 'react';
// import sampleLogo from '../Assets/Images/HHG_Final_Logo_2.png';
// import { Link } from "react-router-dom";
// import locationIcon from '../Assets/icon/Vectorloc.png';

// const Footer = () => {
//     return (
//         <footer itemscope="itemscope" itemtype="https://schema.org/WPFooter">
//             {/* Main Footer Section with Gradient Background */}
//             <div className="footer-main">
//                 <div className="footer-container">
//                     {/* Column 1: Logo, Description & Addresses */}
//                     <div className="footer-column">
//                         <div className="footer-logo">
//                             <Link to="/">
//                                 <img 
//                                     fetchpriority="high"
//                                     width="450"
//                                     height="100"
//                                     src={sampleLogo}
//                                     className="footer-logo-img"
//                                     alt="Home Logo"
//                                     decoding="async"
//                                 />
//                             </Link>
//                         </div>
//                         <div className="footer-description">
//                             This insightful exploration delves into the latest advances in robotic technologies, artificial intelligence, and automation.
//                         </div>
//                         <div className="footer-address">
//                             <img src={locationIcon} alt="Location Icon" className="address-icon" />
//                             <span>
//                                 5th Floor Urbanwrk, West Port, 54, Pancard Club Rd,<br /> Baner, Pune, Maharashtra 411069
//                             </span>
//                         </div>
//                         <div className="footer-address">
//                             <img src={locationIcon} alt="Location Icon" className="address-icon" />
//                             <span>
//                                 42/2, Savli GIDC Rd, Vadodara, Manjusar, Gujarat 391776
//                             </span>
//                         </div>
//                     </div>

//                     {/* Column 2: Quick Links */}
//                     <div className="footer-column">
//                         <h4 className="footer-heading">Quick Links</h4>
//                         <ul className="footer-links">
//                             <li><Link to="/">Home</Link></li>
//                             <li><Link to="Products">Products</Link></li>
//                             <li><Link to="about">About</Link></li>
//                             <li><Link to="ContactUs">Contact</Link></li>
//                             <li><Link to="Career">Career</Link></li>
//                             <li><Link to="TermsOfService">Terms Of Service</Link></li>
//                             <li><Link to="PrivacyPolicy">Privacy Policy</Link></li>
//                         </ul>
//                     </div>

//                     {/* Column 3: Contact Info */}
//                     <div className="footer-column">
//                         <h4 className="footer-heading">Contact Info</h4>
//                         <div className="contact-item">
//                             <i className="fas fa-envelope contact-icon"></i>
//                             <div>
//                                 <h6>Email</h6>
//                                 <p><a href="mailto:inquiry@hhgindia.com">inquiry@hhgindia.com</a></p>
//                             </div>
//                         </div>
//                         <div className="contact-item">
//                             <i className="fas fa-phone-alt contact-icon"></i>
//                             <div>
//                                 <h6>Contact for Queries</h6>
//                                 <p><a href="tel:+919726055997">+91 97260 55997</a></p>
//                             </div>
//                         </div>
//                         <div className="contact-item">
//                             <i className="fas fa-phone-alt contact-icon"></i>
//                             <div>
//                                 <h6>Contact for Career</h6>
//                                 <p><a href="tel:+917069990856">+91 70699 90856</a></p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Column 4: Newsletter & Social Media */}
//                     <div className="footer-column">
//                         <h4 className="footer-heading">Subscribe Our Newsletter!</h4>
//                         <div className="newsletter-form">
//                             <input 
//                                 type="email" 
//                                 placeholder="Your Email Address" 
//                                 className="newsletter-input"
//                             />
//                             <button className="newsletter-button">Subscribe Now</button>
//                         </div>
//                         <div className="social-icons">
//                             <a href="https://www.facebook.com/profile.php?viewas=100000686899395&id=61580761602005" target="_blank" rel="noopener noreferrer" className="social-icon">
//                                 <i className="fab fa-facebook-f"></i>
//                             </a>
//                             <a href="https://x.com/HHGIndustries" target="_blank" rel="noopener noreferrer" className="social-icon">
//                                 <i className="fab fa-twitter"></i>
//                             </a>
//                             <a href="https://www.youtube.com/@hhgindustries" target="_blank" rel="noopener noreferrer" className="social-icon">
//                                 <i className="fab fa-youtube"></i>
//                             </a>
//                             <a href="https://www.instagram.com/hhgindustries/" target="_blank" rel="noopener noreferrer" className="social-icon">
//                                 <i className="fab fa-instagram"></i>
//                             </a>
//                             <a href="https://www.linkedin.com/company/hhg-industries-private-limited" target="_blank" rel="noopener noreferrer" className="social-icon">
//                                 <i className="fab fa-linkedin"></i>
//                             </a>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Bottom Bar: Copyright & Legal Links */}
//             <div className="footer-bottom">
//                 <div className="footer-bottom-container">
//                     <div className="copyright">
//                         Copyright © 2024 HHG Industries Private Limited. All rights reserved.
//                     </div>
//                     <div className="legal-links">
//                         <Link to="TermsOfService">Terms & Conditions</Link>
//                         <Link to="PrivacyPolicy">Privacy Policy</Link>
//                     </div>
//                 </div>
//             </div>

//             {/* Responsive Styles */}
//             <style jsx>{`
//                 /* Reset and Base Styles */
//                 .footer-main {
//                     background: linear-gradient(135deg, #f5f7fa 0%, #e9edf2 100%);
//                     padding: 60px 0 40px;
//                     font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
//                 }

//                 .footer-container {
//                     max-width: 1200px;
//                     margin: 0 auto;
//                     padding: 0 20px;
//                     display: grid;
//                     grid-template-columns: repeat(4, 1fr);
//                     gap: 30px;
//                 }

//                 /* Column Styles */
//                 .footer-column {
//                     display: flex;
//                     flex-direction: column;
//                     gap: 20px;
//                 }

//                 .footer-logo-img {
//                     max-width: 100%;
//                     height: auto;
//                     width: 280px;
//                     cursor: pointer;
//                 }

//                 .footer-description {
//                     font-size: 14px;
//                     line-height: 1.6;
//                     color: #333;
//                     margin: 10px 0;
//                 }

//                 .footer-address {
//                     display: flex;
//                     align-items: flex-start;
//                     gap: 10px;
//                     font-size: 14px;
//                     color: #555;
//                     line-height: 1.5;
//                 }

//                 .address-icon {
//                     width: 18px;
//                     height: 18px;
//                     flex-shrink: 0;
//                     margin-top: 2px;
//                 }

//                 .footer-heading {
//                     font-size: 18px;
//                     font-weight: 600;
//                     margin: 0 0 10px 0;
//                     color: #1a1a1a;
//                     position: relative;
//                 }

//                 .footer-heading:after {
//                     content: '';
//                     position: absolute;
//                     bottom: -8px;
//                     left: 0;
//                     width: 40px;
//                     height: 2px;
//                     background: #007bff;
//                 }

//                 .footer-links {
//                     list-style: none;
//                     padding: 0;
//                     margin: 0;
//                 }

//                 .footer-links li {
//                     margin-bottom: 12px;
//                 }

//                 .footer-links a {
//                     color: #555;
//                     text-decoration: none;
//                     transition: color 0.3s ease;
//                     font-size: 14px;
//                 }

//                 .footer-links a:hover {
//                     color: #007bff;
//                 }

//                 /* Contact Items */
//                 .contact-item {
//                     display: flex;
//                     align-items: flex-start;
//                     gap: 15px;
//                     margin-bottom: 20px;
//                 }

//                 .contact-icon {
//                     font-size: 20px;
//                     color: #007bff;
//                     width: 25px;
//                     margin-top: 3px;
//                 }

//                 .contact-item h6 {
//                     margin: 0 0 5px 0;
//                     font-size: 14px;
//                     font-weight: 600;
//                     color: #333;
//                 }

//                 .contact-item p {
//                     margin: 0;
//                 }

//                 .contact-item a {
//                     color: #666;
//                     text-decoration: none;
//                     font-size: 14px;
//                     transition: color 0.3s ease;
//                 }

//                 .contact-item a:hover {
//                     color: #007bff;
//                 }

//                 /* Newsletter Form */
//                 .newsletter-form {
//                     display: flex;
//                     flex-direction: column;
//                     gap: 12px;
//                     margin: 10px 0;
//                 }

//                 .newsletter-input {
//                     padding: 12px 15px;
//                     border: 1px solid #ddd;
//                     border-radius: 5px;
//                     font-size: 14px;
//                     outline: none;
//                     transition: border-color 0.3s ease;
//                 }

//                 .newsletter-input:focus {
//                     border-color: #007bff;
//                 }

//                 .newsletter-button {
//                     padding: 12px 20px;
//                     background: #007bff;
//                     color: white;
//                     border: none;
//                     border-radius: 5px;
//                     cursor: pointer;
//                     font-size: 14px;
//                     font-weight: 500;
//                     transition: background 0.3s ease;
//                 }

//                 .newsletter-button:hover {
//                     background: #0056b3;
//                 }

//                 /* Social Icons */
//                 .social-icons {
//                     display: flex;
//                     gap: 15px;
//                     margin-top: 15px;
//                     flex-wrap: wrap;
//                 }

//                 .social-icon {
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     width: 40px;
//                     height: 40px;
//                     background: white;
//                     border-radius: 50%;
//                     color: #007bff;
//                     text-decoration: none;
//                     transition: all 0.3s ease;
//                     box-shadow: 0 2px 5px rgba(0,0,0,0.1);
//                 }

//                 .social-icon:hover {
//                     background: #007bff;
//                     color: white;
//                     transform: translateY(-3px);
//                 }

//                 /* Bottom Bar */
//                 .footer-bottom {
//                     background: #1a1a2e;
//                     color: #aaa;
//                     padding: 20px 0;
//                     font-size: 13px;
//                 }

//                 .footer-bottom-container {
//                     max-width: 1200px;
//                     margin: 0 auto;
//                     padding: 0 20px;
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     flex-wrap: wrap;
//                     gap: 15px;
//                 }

//                 .legal-links {
//                     display: flex;
//                     gap: 25px;
//                 }

//                 .legal-links a {
//                     color: #aaa;
//                     text-decoration: none;
//                     transition: color 0.3s ease;
//                 }

//                 .legal-links a:hover {
//                     color: white;
//                 }

//                 /* Responsive Breakpoints */
//                 @media (max-width: 1024px) {
//                     .footer-container {
//                         gap: 25px;
//                     }
//                 }

//                 @media (max-width: 768px) {
//                     .footer-main {
//                         padding: 40px 0 30px;
//                     }

//                     .footer-container {
//                         grid-template-columns: 1fr;
//                         gap: 35px;
//                     }

//                     .footer-column {
//                         text-align: center;
//                         align-items: center;
//                     }

//                     .footer-address {
//                         justify-content: center;
//                         text-align: center;
//                     }

//                     .footer-heading:after {
//                         left: 50%;
//                         transform: translateX(-50%);
//                     }

//                     .contact-item {
//                         justify-content: center;
//                         text-align: center;
//                     }

//                     .social-icons {
//                         justify-content: center;
//                     }

//                     .newsletter-form {
//                         width: 100%;
//                         max-width: 350px;
//                         margin: 0 auto;
//                     }

//                     .footer-bottom-container {
//                         flex-direction: column;
//                         text-align: center;
//                     }

//                     .legal-links {
//                         justify-content: center;
//                     }
//                 }

//                 @media (max-width: 480px) {
//                     .footer-container {
//                         padding: 0 15px;
//                     }

//                     .footer-logo-img {
//                         width: 220px;
//                     }

//                     .footer-description {
//                         font-size: 13px;
//                     }

//                     .footer-address {
//                         font-size: 13px;
//                         flex-direction: column;
//                         align-items: center;
//                     }

//                     .address-icon {
//                         margin-bottom: 5px;
//                     }

//                     .contact-item {
//                         flex-direction: column;
//                         align-items: center;
//                     }

//                     .legal-links {
//                         flex-direction: column;
//                         gap: 10px;
//                     }

//                     .newsletter-input,
//                     .newsletter-button {
//                         width: 100%;
//                     }
//                 }

//                 /* Tablet Landscape */
//                 @media (min-width: 769px) and (max-width: 992px) {
//                     .footer-container {
//                         grid-template-columns: repeat(2, 1fr);
//                         gap: 35px;
//                     }
//                 }
//             `}</style>
//         </footer>
//     );
// };

// export default Footer;


